/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Link } from "../../../../utils/Link";
import { Link as GatsbyLink } from "gatsby";
import { useTranslation } from "react-i18next";
import { usePageContext } from "../../../../utils/PageContext";
import { useCollapsible } from "../CategoriesNav";

export default function HeaderTop({ onShowSearch, data }) {
  const { t } = useTranslation();
  const { lang, articleType } = usePageContext();

  const isBusiness = articleType === "BUSINESS";
  const isAboutUs = articleType === "ABOUT_US";
  const isPersonal = !isBusiness && !isAboutUs;

  const languageToChangeTo = lang === "sq" ? "en" : "sq";

  const path = typeof window !== "undefined" ? window.location.pathname : "";

  const menu = [
    {
      text: `${t("pages.contact.label")}`,
      link: "/contact",
      icon: "i-phone-alt",
    },
    // {
    //   text: t("pages.branches.label"),
    //   link: "/branches",
    //   icon: "i-map-marker-alt",
    // },
    // {
    //   text: t("pages.about.label"),
    //   link: "/about",
    //   icon: "i-users-alt",
    // },
    {
      text: t("pages.news.label"),
      link: "/lajme/njoftime",
      icon: "i-newspaper",
    },
    // {
    //   text: t("pages.help.label"),
    //   link: "/help",
    //   icon: "i-shield-question",
    // },
  ];

  const collapsibleMoreMenu = useCollapsible(
    ["header-top__dropdown", "header-top__dropdown--alt"],
    "header-top__dropdown--active"
  );

  const BUSINESS_LABEL = t("business");
  const PERSONAL_LABEL = t("personal");
  const ABOUT_US_LABEL = t("pages.about.label");

  return (
    <div className="header-top">
      <div className="wrapper header-top__wrapper">
        <div className="header-top__wrapper-item"></div>
        <div
          className="header-top__wrapper-item"
          style={{ transform: "translateX(-30px)" }}
        >
          <ul className="header-top__list">
            {menu.map(({ text, icon, link }) => {
              let toLink = "";

              if (typeof link === "string") {
                toLink = link;
              } else {
                toLink = isBusiness ? link.business : link.personal;
              }

              return (
                <li className="header-top__list-item" key={text}>
                  <Link to={toLink}>
                    <i className={`icon ${icon}`} />
                    {text}
                  </Link>
                </li>
              );
            })}
            <li className="header-top__list-item header-top__list-item--less-mr">
              <GatsbyLink
                className="text-white"
                to={path.replace(`/${lang}`, `/${languageToChangeTo}`)}
              >
                {languageToChangeTo === "sq" ? "Shqip" : "English"}
              </GatsbyLink>
            </li>
            {/* <li className="header-top__list-item header-top__list-item--less-mr">
              <a
                href="#"
                className="js-open__search"
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  onShowSearch();
                }}
              >
                <i className="i-search-alt" />
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}
